import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import API_BASE_URL from '../Config';

const CategoriasDocumentoList = () => {
    const [categorias, setCategorias] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        fetchCategorias();
    }, []);

    const fetchCategorias = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await fetch(`${API_BASE_URL}/categorias-documento`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (!response.ok) throw new Error('No se pudieron cargar las categorías');
            const data = await response.json();
            setCategorias(Array.isArray(data) ? data : []);
        } catch (error) {
            Swal.fire('Error', error.message, 'error');
        } finally {
            setLoading(false);
        }
    };

    const handleEliminar = async (id) => {
        const confirm = await Swal.fire({
            title: '¿Estás seguro?',
            text: 'Esta acción no se puede deshacer',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#d33'
        });

        if (confirm.isConfirmed) {
            try {
                const token = localStorage.getItem('token');
                const response = await fetch(`${API_BASE_URL}/categorias-documento/${id}`, {
                    method: 'DELETE',
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                if (!response.ok) throw new Error('No se pudo eliminar la categoría');
                Swal.fire('Eliminado', 'La categoría fue eliminada correctamente', 'success');
                fetchCategorias();
            } catch (error) {
                Swal.fire('Error', error.message, 'error');
            }
        }
    };

    const filteredCategorias = categorias.filter(c =>
        c.nombre?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        c.valor?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div className="container-fluid py-5 px-lg-5" style={{ backgroundColor: '#f8fafc', minHeight: '100vh' }}>
            <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-3">
                <div>
                    <h2 className="fw-bolder text-dark mb-1">Categorías de Documento</h2>
                    <p className="text-muted mb-0">Parametrización del sistema</p>
                </div>
                <button
                    className="btn btn-primary rounded-pill fw-bold px-4"
                    onClick={() => navigate('/parametrizacion/categorias-documento/nuevo')}
                >
                    <i className="bi bi-plus-circle me-2"></i>
                    Nueva Categoría
                </button>
            </div>

            <div className="input-group shadow-sm mb-4" style={{ maxWidth: '400px' }}>
                <span className="input-group-text bg-white border-end-0 ps-3 rounded-start-pill">
                    <i className="bi bi-search text-muted"></i>
                </span>
                <input
                    type="text"
                    className="form-control border-start-0 py-2 rounded-end-pill"
                    placeholder="Buscar por nombre o valor..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
            </div>

            {loading ? (
                <div className="d-flex align-items-center">
                    <div className="spinner-border text-primary me-3"></div>
                    <span className="text-muted">Cargando categorías...</span>
                </div>
            ) : filteredCategorias.length === 0 ? (
                <div className="text-center py-5 opacity-50">
                    <i className="bi bi-inbox display-1 text-muted"></i>
                    <h5 className="mt-3 text-secondary">No hay categorías registradas</h5>
                </div>
            ) : (
                <div className="card border-0 shadow-sm rounded-4 overflow-hidden bg-white">
                    <div className="table-responsive">
                        <table className="table table-hover align-middle mb-0">
                            <thead className="bg-light">
                                <tr>
                                    <th className="ps-4 py-3 text-uppercase small text-secondary fw-bold">ID</th>
                                    <th className="py-3 text-uppercase small text-secondary fw-bold">Valor</th>
                                    <th className="py-3 text-uppercase small text-secondary fw-bold">Nombre</th>
                                    <th className="pe-4 py-3 text-end text-uppercase small text-secondary fw-bold">Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredCategorias.map(c => (
                                    <tr key={c.id}>
                                        <td className="ps-4 fw-medium">{c.id}</td>
                                        <td><span className="badge bg-secondary rounded-pill px-3">{c.valor}</span></td>
                                        <td className="fw-bold text-dark">{c.nombre}</td>
                                        <td className="pe-4 text-end d-flex justify-content-end gap-2">
                                            <button
                                                className="btn btn-sm btn-outline-primary rounded-pill px-3 fw-bold"
                                                onClick={() => navigate(`/parametrizacion/categorias-documento/${c.id}/editar`)}
                                            >
                                                Editar
                                            </button>
                                            <button
                                                className="btn btn-sm btn-outline-danger rounded-pill px-3 fw-bold"
                                                onClick={() => handleEliminar(c.id)}
                                            >
                                                Eliminar
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
        </div>
    );
};

export default CategoriasDocumentoList;